<template>
     <v-dialog
      v-model="dialog"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          TheShopFront
        </v-card-title>
        <v-card-text class="d-flex justify-center">
            {{ message }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            text
            @click="closeDialog()"
          >
            Okay
          </v-btn>
        
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'Disclaimer',
    data () {
        return {
            message: 'TheShopFront is currently under development and may experience changes as time goes by.'
        }
    },
    methods:{
        closeDialog()  {
          this.$store.commit('hideDisclaimer');
        },
    },
    computed: {
      dialog() {
        return this.$store.getters.dialog
      }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Disclaimer.vue